var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "17",
        height: "15",
        viewBox: "0 0 17 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M5.52529 10.068C8.57732 10.068 11.0503 7.97489 11.0503 5.39302C11.0503 2.81114 8.57732 0.718018 5.52529 0.718018C2.47326 0.718018 0.000290712 2.81114 0.000290712 5.39302C0.000290712 6.41833 0.390759 7.36661 1.05217 8.13958C0.959197 8.38927 0.821072 8.60974 0.674978 8.79567C0.547478 8.96036 0.417322 9.08786 0.321697 9.17552C0.273884 9.21802 0.234041 9.25255 0.207478 9.2738C0.194197 9.28442 0.183572 9.29239 0.178259 9.29505L0.172947 9.30036C0.0268532 9.40927 -0.0368968 9.60052 0.0215407 9.77317C0.0799782 9.94583 0.242009 10.068 0.425291 10.068C1.00435 10.068 1.58873 9.91927 2.07482 9.73599C2.3192 9.64302 2.54763 9.53942 2.74685 9.43317C3.56232 9.83692 4.5106 10.068 5.52529 10.068ZM11.9003 5.39302C11.9003 8.37599 9.26795 10.6232 6.14951 10.8915C6.79498 12.8677 8.93592 14.318 11.4753 14.318C12.49 14.318 13.4383 14.0869 14.2564 13.6832C14.4556 13.7894 14.6814 13.893 14.9258 13.986C15.4119 14.1693 15.9962 14.318 16.5753 14.318C16.7586 14.318 16.9233 14.1985 16.979 14.0232C17.0348 13.8479 16.9737 13.6566 16.825 13.5477L16.8197 13.5424C16.8144 13.5371 16.8037 13.5318 16.7904 13.5211C16.7639 13.4999 16.724 13.468 16.6762 13.4229C16.5806 13.3352 16.4504 13.2077 16.3229 13.043C16.1769 12.8571 16.0387 12.634 15.9458 12.3869C16.6072 11.6166 16.9976 10.6683 16.9976 9.64036C16.9976 7.17536 14.7425 5.15395 11.8817 4.97864C11.8923 5.11411 11.8976 5.25224 11.8976 5.39036L11.9003 5.39302Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }